export enum ComponentEnum {
    DatePicker,
    LocationPicker,
    CategoryPicker,
    MultiSelectPicker,
    NumberPicker,
    StringPicker,
    BooleanPicker,
    ImagePicker,
    SpecimenPicker,
    TaxonPicker,
    PersonPicker,
}